import styled from 'styled-components'

export const RatingWrapper = styled.div`
  font-size: 16px;
  line-height: 20px;
`
